import { registerPlugin } from '@capacitor/core';
const PejCapPrinterPlugin = registerPlugin('PejCapPrinterPlugin', {
    web: () => import('./web').then((m) => new m.PejCapPrinterPluginWeb()),
});
export * from './definitions';
export * from './printer-order.interfaces';
export { PejCapPrinterPlugin };
//# sourceMappingURL=index.js.map